import React from "react";
import { Button } from "@campgladiator/cgui-core.atoms.button";
import { PaginationProps } from "../../";
import styles from "./number-button.module.scss";

type NumberButtonItemProps = {
  active: boolean;
  children: number;
  onClick: (page: number) => void;
  size: PaginationProps["size"];
};

const NumberButton = ({
  active,
  size,
  children,
  onClick,
}: NumberButtonItemProps) => {
  const variation = active ? "solid" : "text";

  return (
    <Button
      emphasis="secondary"
      variation={variation}
      size={size}
      className={styles.numberButton}
      data-size={size}
      onClick={() => onClick(children)}
    >
      {children}
    </Button>
  );
};

export default NumberButton;
